module.exports = __webpack_public_path__ + "static/media/bdot_title_white.3cb76b2e.webp";